import { FeatureType } from 'modules/predictiveGoals/types';

export const XAI_LIKELY_FEATURE_TYPES_TEXT = {
  [FeatureType.PROPERTY]: 'Property',
  [FeatureType.PURCHASEEVENT]: 'Purchase Event',
  [FeatureType.CUSTOMEVENT]: 'Custom Event',
  [FeatureType.SYSTEMEVENT]: 'System Event',
};
